import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

const Image = ({src, alt, sx = {}}) => {
  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      sx={{
        maxWidth: '100%',
        height: 'auto',
        ...sx,
      }}
    />
  );
};

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  sx: PropTypes.object,
};

export default Image;
